/* Copyright (c) 2022 Xperi. All Rights Reserved. */

import { Locale } from '../../../core/locale/Locale';
import { LocaleKeys } from '../../../core/locale/LocaleKeys';
import { hideOverlayDialog, showOverlayDialog } from '../../overlaydialog/overlaydialog.reducers';
import { IOverlayDialog } from '../../overlaydialog/overlaydialogprops';
import { DeviceModel } from '../../../core/device';
import { VuLogger } from '../../../core/logging';
import { ScreenTaskControllerTypes } from '../../../core/navigation/ScreenTaskControllerTypes';
import { setScreenTaskController } from '../../screens/screens.reducers';
import { OverlayTypes } from '../OverlayTypes';

const GLOBAL_MOUSE_TRAP: string = 'HideTemporaryGuideIssueOverlay';

/* TODO: Get confirmation if this same Ovleray can be used in Filteredguide in future.
 If not, move this overlay to Guide directory and extract error from gridGuide state. */
export const showTemporaryGuideIssueOverlay = (error?: any) => (dispatch: Function) => {
    dispatch(setScreenTaskController(ScreenTaskControllerTypes.TEMPORARY_GUIDE_ISSUE_OVERLAY));
    const overlayOptions = [{ text: Locale.getString(LocaleKeys.OVERLAY_OPTION_OK_TEXT) }];
    if (DeviceModel.isWebOsPlatform()) {
        overlayOptions.push({ text: Locale.getString(LocaleKeys.OVERLAY_OPTION_GO_TO_SETTINGS) });
    }
    const overlayDialogProps: IOverlayDialog = {
        description: Locale.getString(LocaleKeys.GUIDE_TEMPORARY_GUIDE_ISSUE_OVERLAY_DESCRIPTION),
        hasDimmer: true,
        hasSeperator: false,
        messageCode: error?.getCode(),
        mouseTrapValue: GLOBAL_MOUSE_TRAP,
        options: overlayOptions,
        overlayType: OverlayTypes.TEMPORARY_GUIDE_ISSUE,
        title: Locale.getString(LocaleKeys.GUIDE_TEMPORARY_GUIDE_ISSUE_OVERLAY_TITLE),
    };
    dispatch(showOverlayDialog(overlayDialogProps));
};

export const hideTemporaryGuideIssueOverlay = () => (dispatch: Function) => {
    dispatch(hideOverlayDialog());
};

export const onKeyOkTemporaryGuideIssueOverlay = () => (dispatch: Function, getState: Function) => {
    const { verticalPosition } = getState().overlayHighlight;
    dispatch(hideOverlayDialog());
    if (verticalPosition === 0) VuLogger.logTemporaryGuideIssueOverlayOkUserAction();
    if (verticalPosition === 1) DeviceModel.launchSystemSetting();
};

export const onKeyBackTemporaryGuideIssueOverlay = () => (dispatch: Function) => {
    VuLogger.logTemporaryGuideIssueOverlayCancelUserAction();
    dispatch(hideOverlayDialog());
};

export const onMouseClickTemporaryGuideIssueOverlay =
    () => (dispatch: Function, getState: Function) => {
        const { value } = getState().inputFactory;

        if (value === GLOBAL_MOUSE_TRAP) {
            dispatch(hideOverlayDialog());
            return;
        }
        dispatch(onKeyOkTemporaryGuideIssueOverlay());
    };
